import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { SecurityDateTime } from '../security/SecurityIntegration.jsx';

/**
 * SetupAlreadyConfigured — shown when /api/auth/status returns isSetup: true.
 * Lets the user navigate back to the login screen.
 */
export function SetupAlreadyConfigured({ onSwitchToLogin, checkSetup }) {
  return (
    <div className="auth-page">
      <div style={{ position: 'absolute', top: 20, right: 28 }}>
        <SecurityDateTime style={{ color: 'var(--auth-text-muted)' }} />
      </div>
      <div className="auth-page-grid" />
      <div className="auth-shell">
        <div className="auth-logo-wrap">
          <div className="auth-logo-badge" style={{ background: '#f59e0b', boxShadow: '0 0 32px rgba(245,158,11,0.4)' }}>
            <AlertTriangle size={26} color="#fff" />
          </div>
          <h1 className="auth-title">System Already Configured</h1>
          <p className="auth-subtitle">First-time setup has already been completed</p>
        </div>
        <div className="auth-card" data-testid="setup-already-configured">
          <p style={{ color: 'var(--auth-text-muted)', fontSize: 12, lineHeight: 1.7, marginBottom: 20 }}>
            An administrator password is already configured on this installation. Please use the{' '}
            <strong>Login</strong> screen to sign in, or use <strong>Forgot Password</strong> to
            reset credentials via the recovery email.
          </p>
          <button
            type="button"
            className="auth-submit"
            data-testid="setup-goto-login"
            onClick={async () => { await checkSetup(); if (onSwitchToLogin) onSwitchToLogin(); }}
            style={{ background: 'var(--brand-blue)', boxShadow: '0 4px 16px rgba(59,130,246,0.3)' }}
          >
            Go to Login
          </button>
        </div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg);}}`}</style>
    </div>
  );
}
